<template>
  <span>
    <AppIcon :icon="icon" :color="iconColor" start />
    <span class="me-1">
      {{ label }}
    </span>
    <PriceSpan
      v-if="value != 'none'"
      :price="fee"
      operand="+"
    />
  </span>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import useLocalization from '~/composables/use-localization';
import type { VisaForm, Price } from '~/types';

const props = defineProps<{
  fee: Price;
  value: VisaForm['urgency'];
  isAppointment: boolean;
}>();

const country = inject(countryKeyInjectionKey)!;
const { tWaitDays, tt } = useLocalization();
const label = tt(`priority.select_${props.value}`, { wait: tWaitDays(country) });

const icon = props.value === 'none' ? 'mdi:clock-outline' : 'mdi:stopwatch-outline';
const iconColor = props.value === 'none' ? undefined : '#e00817';
</script> 